(()=>{
  'use strict';

  /* Defer desktop hero video. Mobile uses the high-priority poster instead. */
  const bootHeroVideo=()=>{
    const video=document.querySelector('[data-pne-deferred-hero-video]');
    if(!video)return;
    const wide=window.matchMedia('(min-width: 750px)').matches;
    const saveData=!!(navigator.connection&&navigator.connection.saveData);
    if(!wide||saveData)return;
    let hydrated=false;
    video.querySelectorAll('source[data-src]').forEach(source=>{
      source.src=source.dataset.src;
      source.removeAttribute('data-src');
      hydrated=true;
    });
    if(hydrated){
      video.load();
      const play=video.play();
      if(play&&typeof play.catch==='function')play.catch(()=>{});
    }
  };

  const STORAGE='PNE_SAVED_RELEASES_V1';
  const MAX_SAVED=12;
  const $=(sel,scope=document)=>scope.querySelector(sel);
  const $$=(sel,scope=document)=>Array.from(scope.querySelectorAll(sel));
  const esc=(value='')=>String(value).replace(/[&<>'"]/g,ch=>({ '&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#039;','"':'&quot;' }[ch]));

  const read=()=>{
    try{
      const parsed=JSON.parse(localStorage.getItem(STORAGE)||'[]');
      return Array.isArray(parsed)?parsed:[];
    }catch(e){return[];}
  };
  const write=(items)=>{
    try{localStorage.setItem(STORAGE,JSON.stringify(items.slice(0,MAX_SAVED)));}catch(e){}
    refresh();
  };
  const fromButton=(button)=>({
    id:String(button.dataset.savedId||''),
    title:button.dataset.savedTitle||'',
    url:button.dataset.savedUrl||'#',
    image:button.dataset.savedImage||'',
    price:button.dataset.savedPrice||'',
    status:button.dataset.savedStatus||''
  });
  const isSaved=(id,items=read())=>items.some(item=>String(item.id)===String(id));

  const toggle=(button)=>{
    const item=fromButton(button);
    if(!item.id)return;
    let items=read();
    if(isSaved(item.id,items)) items=items.filter(saved=>String(saved.id)!==item.id);
    else items=[item,...items.filter(saved=>String(saved.id)!==item.id)];
    write(items);
  };

  const cardHtml=(item,compact=false)=>{
    const image=item.image?`<img src="${esc(item.image)}" alt="${esc(item.title)}" loading="lazy">`:'';
    if(compact){
      return `<a class="pne-v4-return-card" href="${esc(item.url)}">${image}<span class="pne-v4-return-card__copy"><small>${esc(item.status||'SAVED RELEASE')}</small><strong>${esc(item.title)}</strong><b>${esc(item.price)}</b></span></a>`;
    }
    return `<div class="pne-saved-item" data-saved-row="${esc(item.id)}"><a href="${esc(item.url)}" aria-label="${esc(item.title)}">${image}</a><a class="pne-saved-item__copy" href="${esc(item.url)}"><small>${esc(item.status||'SAVED RELEASE')}</small><strong>${esc(item.title)}</strong><b>${esc(item.price)}</b></a><button class="pne-saved-item__remove" type="button" data-pne-saved-remove="${esc(item.id)}" aria-label="Remove ${esc(item.title)}">×</button></div>`;
  };

  const renderDrawer=(items)=>{
    const drawer=$('[data-pne-saved-drawer]');
    if(!drawer)return;
    const wrap=$('[data-pne-saved-items]',drawer);
    const empty=$('[data-pne-saved-empty]',drawer);
    if(wrap)wrap.innerHTML=items.map(item=>cardHtml(item,false)).join('');
    if(empty)empty.hidden=items.length>0;
  };

  const renderReturn=(items)=>{
    const section=$('[data-pne-return-vault]');
    if(!section)return;
    const rail=$('[data-pne-return-items]',section);
    const show=items.length>0;
    section.hidden=!show;
    if(rail)rail.innerHTML=show?items.slice(0,4).map(item=>cardHtml(item,true)).join(''):'';
  };

  const refresh=()=>{
    const items=read();
    $$('[data-pne-saved-count]').forEach(el=>el.textContent=String(items.length));
    $$('[data-pne-save-release]').forEach(button=>{
      const active=isSaved(button.dataset.savedId,items);
      button.classList.toggle('is-saved',active);
      button.setAttribute('aria-pressed',active?'true':'false');
      const icon=$('[data-pne-save-icon]',button);
      if(icon)icon.textContent=active?'✓':'＋';
      const text=$('[data-pne-save-text]',button);
      if(text){
        const ja=document.documentElement.lang.toLowerCase().startsWith('ja');
        text.textContent=active?(ja?'保存済み':'SAVED TO MY VAULT'):(ja?'このリリースを保存':'SAVE RELEASE TO MY VAULT');
      }
    });
    renderDrawer(items);
    renderReturn(items);
  };

  const openDrawer=()=>{
    const drawer=$('[data-pne-saved-drawer]');
    if(!drawer)return;
    refresh();
    drawer.hidden=false;
    drawer.setAttribute('aria-hidden','false');
    document.documentElement.classList.add('pne-saved-open');
    $('[data-pne-saved-close]',drawer)?.focus({preventScroll:true});
  };
  const closeDrawer=()=>{
    const drawer=$('[data-pne-saved-drawer]');
    if(!drawer)return;
    drawer.hidden=true;
    drawer.setAttribute('aria-hidden','true');
    document.documentElement.classList.remove('pne-saved-open');
  };

  document.addEventListener('click',event=>{
    const save=event.target.closest('[data-pne-save-release]');
    if(save){event.preventDefault();event.stopPropagation();toggle(save);return;}
    if(event.target.closest('[data-pne-saved-open]')){event.preventDefault();openDrawer();return;}
    if(event.target.closest('[data-pne-saved-close]')){event.preventDefault();closeDrawer();return;}
    const remove=event.target.closest('[data-pne-saved-remove]');
    if(remove){
      event.preventDefault();
      const id=String(remove.dataset.pneSavedRemove||'');
      write(read().filter(item=>String(item.id)!==id));
    }
  });
  document.addEventListener('keydown',event=>{if(event.key==='Escape')closeDrawer();});

  const init=()=>{bootHeroVideo();refresh();};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
})();
